import { useState } from 'react';
import { SelectedItem } from '../page';

interface Category {
  id: number;
  name: string;
  desc: string;
  badge: string;
  badgeColor: string;
  bg: string;
  image: string;
  images: string[];
  origin: string;
  season: string;
  taste: string;
  nutrition: string;
  tip: string;
  prices: { weight: string; price: string }[];
}

interface FruitCategoriesProps {
  onSelectItem: (item: SelectedItem) => void;
  selectedItems: SelectedItem[];
}

const categories: Category[] = [
  {
    id: 1,
    name: '대저토마토 가정용혼합',
    desc: '부산 대저 산지직송 혼합과',
    badge: '산지직송',
    badgeColor: 'bg-red-500',
    bg: 'bg-rose-50',
    image: 'https://static.readdy.ai/image/684ef825f0900504e8b31e83da06292a/821b41a4d4cfbaa6899889f299baf12c.jpeg',
    images: [
      'https://static.readdy.ai/image/684ef825f0900504e8b31e83da06292a/821b41a4d4cfbaa6899889f299baf12c.jpeg',
      'https://static.readdy.ai/image/684ef825f0900504e8b31e83da06292a/719656f3903a1b094fe7d649be84d162.jpeg',
      'https://static.readdy.ai/image/684ef825f0900504e8b31e83da06292a/419acac5b1fd706a29bb5428026494ce.jpeg',
    ],
    origin: '부산 강서구 대저동',
    season: '3월 ~ 6월',
    taste: '짭짤하고 달콤한 맛, 과즙이 풍부하며 독특한 풍미',
    nutrition: '라이코펜, 비타민C·A, 칼륨, 항산화 성분 풍부',
    tip: '상온 보관 후 드시고, 냉장 보관 시 맛이 떨어질 수 있어요.',
    prices: [
      { weight: '1kg', price: '9,900원' },
      { weight: '2.5kg', price: '14,000원' },
    ],
  },
  {
    id: 2,
    name: '대저토마토 짭짤이',
    desc: '짭짤한 풍미의 프리미엄 토마토',
    badge: '프리미엄',
    badgeColor: 'bg-orange-600',
    bg: 'bg-orange-50',
    image: 'https://static.readdy.ai/image/684ef825f0900504e8b31e83da06292a/1a654c09c9889623365584b102c240fb.jpeg',
    images: [
      'https://static.readdy.ai/image/684ef825f0900504e8b31e83da06292a/1a654c09c9889623365584b102c240fb.jpeg',
      'https://static.readdy.ai/image/684ef825f0900504e8b31e83da06292a/2bbdbeef5217cf702d08e7380598fca3.jpeg',
      'https://static.readdy.ai/image/684ef825f0900504e8b31e83da06292a/c2891857a5c31db0c94d46b8fdb521e7.jpeg',
    ],
    origin: '부산 강서구 대저동',
    season: '3월 ~ 6월',
    taste: '짭짤하고 달콤한 독특한 맛, 일반 토마토보다 당도 높음',
    nutrition: '라이코펜, 비타민C, 칼륨, 베타카로틴 풍부',
    tip: '꼭지가 싱싱하고 껍질이 팽팽한 것을 고르세요.',
    prices: [
      { weight: '1kg', price: '14,500원' },
      { weight: '2.5kg', price: '26,500원' },
    ],
  },
  {
    id: 3,
    name: '부사사과 A급(중대과)',
    desc: '경북 청송 최상급 부사사과',
    badge: 'A급',
    badgeColor: 'bg-green-600',
    bg: 'bg-green-50',
    image: 'https://static.readdy.ai/image/684ef825f0900504e8b31e83da06292a/7c0bcf392b8289b605f057b85ca755c2.jpeg',
    images: [
      'https://static.readdy.ai/image/684ef825f0900504e8b31e83da06292a/7c0bcf392b8289b605f057b85ca755c2.jpeg',
      'https://static.readdy.ai/image/684ef825f0900504e8b31e83da06292a/2d3ce1e186290565cef81539860a25bc.jpeg',
      'https://static.readdy.ai/image/684ef825f0900504e8b31e83da06292a/c50f6ecfa7a7cb1bbcbea64f4eb2c426.jpeg',
    ],
    origin: '경북 청송, 충북 충주',
    season: '10월 ~ 11월 (저장 후 연중)',
    taste: '아삭하고 달콤한 맛, 과즙이 풍부하고 당도 높음',
    nutrition: '식이섬유, 비타민C, 폴리페놀, 퀘르세틴 풍부',
    tip: '냉장 보관 시 신선도가 오래 유지됩니다.',
    prices: [
      { weight: '1kg', price: '9,500원' },
      { weight: '2kg', price: '14,000원' },
      { weight: '3kg', price: '16,500원' },
      { weight: '5kg', price: '25,000원' },
    ],
  },
  {
    id: 4,
    name: '부사사과 B급(중대과)',
    desc: '합리적인 가격의 부사사과',
    badge: 'B급',
    badgeColor: 'bg-amber-600',
    bg: 'bg-amber-50',
    image: 'https://static.readdy.ai/image/684ef825f0900504e8b31e83da06292a/cd36fac927c6667d8fd8bf196459e5f2.jpeg',
    images: [
      'https://static.readdy.ai/image/684ef825f0900504e8b31e83da06292a/cd36fac927c6667d8fd8bf196459e5f2.jpeg',
      'https://static.readdy.ai/image/684ef825f0900504e8b31e83da06292a/28aa88943cc9d24a9b8077d4ae8291b9.jpeg',
      'https://static.readdy.ai/image/684ef825f0900504e8b31e83da06292a/0bca9fd890add913011921401756e42b.jpeg',
    ],
    origin: '경북 청송, 충북 충주',
    season: '10월 ~ 11월 (저장 후 연중)',
    taste: '아삭하고 달콤한 맛, A급과 동일한 맛 품질',
    nutrition: '식이섬유, 비타민C, 폴리페놀, 퀘르세틴 풍부',
    tip: '외관만 다를 뿐 맛과 영양은 A급과 동일해요.',
    prices: [
      { weight: '1kg', price: '8,500원' },
      { weight: '2kg', price: '12,500원' },
      { weight: '3kg', price: '15,000원' },
      { weight: '5kg', price: '22,000원' },
    ],
  },
  {
    id: 5,
    name: '부사사과 쥬스용(혼합)',
    desc: '착즙·주스용 혼합 부사사과',
    badge: '주스용',
    badgeColor: 'bg-yellow-600',
    bg: 'bg-yellow-50',
    image: 'https://static.readdy.ai/image/684ef825f0900504e8b31e83da06292a/f6137fadb5e70538fcf785f2fe176af2.jpeg',
    images: [
      'https://static.readdy.ai/image/684ef825f0900504e8b31e83da06292a/f6137fadb5e70538fcf785f2fe176af2.jpeg',
      'https://static.readdy.ai/image/684ef825f0900504e8b31e83da06292a/ef7b0f29687e2940554c15658a3e345d.jpeg',
      'https://static.readdy.ai/image/684ef825f0900504e8b31e83da06292a/34c651e804194dbce722d6a4c86a96c6.jpeg',
    ],
    origin: '경북 청송, 충북 충주',
    season: '10월 ~ 11월 (저장 후 연중)',
    taste: '당도 높고 과즙 풍부, 주스로 만들면 더욱 달콤',
    nutrition: '식이섬유, 비타민C, 폴리페놀, 사과산 풍부',
    tip: '착즙기나 믹서기로 갈아 드시면 최고예요.',
    prices: [
      { weight: '3kg', price: '9,900원' },
      { weight: '5kg', price: '13,500원' },
      { weight: '10kg', price: '23,000원' },
    ],
  },
  {
    id: 6,
    name: '금귤(낑깡) 특',
    desc: '새콤달콤 껍질째 먹는 금귤',
    badge: '특품',
    badgeColor: 'bg-orange-500',
    bg: 'bg-orange-50',
    image: 'https://static.readdy.ai/image/684ef825f0900504e8b31e83da06292a/6e27bbeb43a8b26a2187149d3e70012e.jpeg',
    images: [
      'https://static.readdy.ai/image/684ef825f0900504e8b31e83da06292a/6e27bbeb43a8b26a2187149d3e70012e.jpeg',
      'https://static.readdy.ai/image/684ef825f0900504e8b31e83da06292a/ac08842427ea71dd0163c6abe0e1be4d.jpeg',
      'https://static.readdy.ai/image/684ef825f0900504e8b31e83da06292a/41be85f09ba36077e2867f2336bb30c9.jpeg',
    ],
    origin: '제주도, 전남 고흥',
    season: '12월 ~ 3월',
    taste: '껍질은 달콤하고 과육은 새콤한 독특한 맛',
    nutrition: '비타민C, 플라보노이드, 칼슘, 식이섬유 풍부',
    tip: '껍질째 통으로 드세요.',
    prices: [
      { weight: '1kg', price: '13,500원' },
      { weight: '2kg', price: '22,000원' },
      { weight: '3kg', price: '32,500원' },
      { weight: '5kg', price: '48,500원' },
    ],
  },
  {
    id: 7,
    name: '못난이 참외(혼합과)',
    desc: '모양은 달라도 맛은 최고!',
    badge: '가성비',
    badgeColor: 'bg-yellow-500',
    bg: 'bg-yellow-50',
    image: 'https://static.readdy.ai/image/684ef825f0900504e8b31e83da06292a/c018425aa50d72e3c9baa61bebdd433c.jpeg',
    images: [
      'https://static.readdy.ai/image/684ef825f0900504e8b31e83da06292a/c018425aa50d72e3c9baa61bebdd433c.jpeg',
      'https://static.readdy.ai/image/684ef825f0900504e8b31e83da06292a/5af71091936b9aefbf7f8ac124a2bb43.jpeg',
      'https://static.readdy.ai/image/684ef825f0900504e8b31e83da06292a/b4a5d438cde901f51b1a0a2d98f989f9.jpeg',
    ],
    origin: '경북 성주',
    season: '5월 ~ 8월',
    taste: '달콤하고 아삭한 맛, 정품과 동일한 맛과 당도',
    nutrition: '비타민C, 엽산, 칼륨, 수분 90% 이상',
    tip: '모양만 다를 뿐 맛과 영양은 정품과 동일해요.',
    prices: [
      { weight: '1kg', price: '9,900원' },
      { weight: '2kg', price: '13,000원' },
      { weight: '3kg', price: '17,500원' },
      { weight: '5kg', price: '26,500원' },
      { weight: '10kg', price: '45,000원' },
    ],
  },
  {
    id: 8,
    name: '가정용 참외(로얄과)',
    desc: '성주 직송 로얄 등급 참외',
    badge: '로얄',
    badgeColor: 'bg-green-500',
    bg: 'bg-green-50',
    image: 'https://static.readdy.ai/image/684ef825f0900504e8b31e83da06292a/186f91cdd3a4953114acdf96a3d0f695.jpeg',
    images: [
      'https://static.readdy.ai/image/684ef825f0900504e8b31e83da06292a/186f91cdd3a4953114acdf96a3d0f695.jpeg',
      'https://static.readdy.ai/image/684ef825f0900504e8b31e83da06292a/7fac597169baaebda46b095b18bdad96.jpeg',
      'https://static.readdy.ai/image/684ef825f0900504e8b31e83da06292a/52f3ddafc397f6ea25d3e021cb709911.jpeg',
    ],
    origin: '경북 성주 (전국 70% 생산)',
    season: '5월 ~ 8월',
    taste: '달콤하고 아삭한 맛, 높은 당도와 풍부한 과즙',
    nutrition: '비타민C, 엽산, 칼륨, 수분 90% 이상',
    tip: '꼭지 부분이 싱싱하고 노란색이 선명한 것을 고르세요.',
    prices: [
      { weight: '1kg', price: '11,500원' },
      { weight: '2kg', price: '16,000원' },
      { weight: '3kg', price: '22,500원' },
      { weight: '5kg', price: '36,000원' },
    ],
  },
  {
    id: 9,
    name: '카라향 중과',
    desc: '제주 산지직송 카라향 감귤',
    badge: '제주산',
    badgeColor: 'bg-orange-500',
    bg: 'bg-rose-50',
    image: 'https://static.readdy.ai/image/684ef825f0900504e8b31e83da06292a/5dd4f7c6207d0335d262763f829a7af0.jpeg',
    images: [
      'https://static.readdy.ai/image/684ef825f0900504e8b31e83da06292a/5dd4f7c6207d0335d262763f829a7af0.jpeg',
      'https://static.readdy.ai/image/684ef825f0900504e8b31e83da06292a/0e221efd84023106724486365212e5fb.jpeg',
      'https://static.readdy.ai/image/684ef825f0900504e8b31e83da06292a/53b218d8f9381411c1575e5a6c7ef012.jpeg',
    ],
    origin: '제주도 서귀포',
    season: '2월 ~ 4월',
    taste: '달콤하고 향긋한 맛, 새콤함이 적고 당도가 높음',
    nutrition: '비타민C, 베타카로틴, 헤스페리딘, 식이섬유 풍부',
    tip: '껍질이 얇아 벗기기 쉬워요.',
    prices: [
      { weight: '2kg', price: '11,500원' },
      { weight: '3kg', price: '16,000원' },
      { weight: '5kg', price: '23,000원' },
      { weight: '10kg', price: '41,000원' },
    ],
  },
  {
    id: 10,
    name: '천혜향',
    desc: '제주 직송 향기로운 천혜향',
    badge: '인기',
    badgeColor: 'bg-red-500',
    bg: 'bg-amber-50',
    image: 'https://static.readdy.ai/image/684ef825f0900504e8b31e83da06292a/a2f8eec3d13f437856d1f3341a9c5e96.jpeg',
    images: [
      'https://static.readdy.ai/image/684ef825f0900504e8b31e83da06292a/a2f8eec3d13f437856d1f3341a9c5e96.jpeg',
      'https://static.readdy.ai/image/684ef825f0900504e8b31e83da06292a/ca7a547cd994faffd3ad59314c465523.jpeg',
      'https://public.readdy.ai/ai/img_res/edited_f798b6556e68a9d2d73ec665bad2a395_b5197c8f.jpg',
    ],
    origin: '제주도 서귀포',
    season: '1월 ~ 3월',
    taste: '달콤하고 향긋한 맛, 과즙이 풍부하고 씨가 없음',
    nutrition: '비타민C, 베타카로틴, 플라보노이드, 칼륨 풍부',
    tip: '껍질이 얇고 향이 강한 것이 신선해요.',
    prices: [
      { weight: '2kg', price: '14,000원' },
      { weight: '3kg', price: '20,000원' },
      { weight: '5kg', price: '31,000원' },
      { weight: '10kg', price: '57,000원' },
    ],
  },
];

const FruitDetailModal = ({
  cat,
  onClose,
  onSelectItem,
  selectedItems,
}: {
  cat: Category;
  onClose: () => void;
  onSelectItem: (item: SelectedItem) => void;
  selectedItems: SelectedItem[];
}) => {
  const [activeImg, setActiveImg] = useState(0);
  const [addedId, setAddedId] = useState<string | null>(null);

  const handlePriceClick = (p: { weight: string; price: string }) => {
    const id = `${cat.id}-${p.weight}`;
    onSelectItem({ id, fruitName: cat.name, weight: p.weight, price: p.price, quantity: 1 });
    setAddedId(id);
    setTimeout(() => setAddedId(null), 1000);
  };

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50"
      onClick={onClose}
    >
      <div
        className="bg-white rounded-3xl overflow-hidden w-full max-w-2xl shadow-xl max-h-[95vh] overflow-y-auto"
        onClick={(e) => e.stopPropagation()}
      >
        {/* 메인 이미지 */}
        <div className="relative w-full bg-gray-50" style={{ minHeight: '420px' }}>
          <img
            src={cat.images[activeImg]}
            alt={`${cat.name} ${activeImg + 1}`}
            className="w-full object-contain transition-opacity duration-300"
            style={{ maxHeight: '520px', minHeight: '420px', display: 'block' }}
          />
          <button
            onClick={onClose}
            className="absolute top-4 right-4 w-9 h-9 flex items-center justify-center bg-white/90 rounded-full cursor-pointer hover:bg-white transition-colors"
          >
            <i className="ri-close-line text-gray-700 text-lg"></i>
          </button>
          <span className={`absolute top-4 left-4 ${cat.badgeColor} text-white text-xs font-bold px-3 py-1 rounded-full`}>
            {cat.badge}
          </span>
          {activeImg > 0 && (
            <button
              onClick={(e) => { e.stopPropagation(); setActiveImg(activeImg - 1); }}
              className="absolute left-3 top-1/2 -translate-y-1/2 w-9 h-9 flex items-center justify-center bg-white/80 hover:bg-white rounded-full cursor-pointer transition-colors"
            >
              <i className="ri-arrow-left-s-line text-gray-700 text-xl"></i>
            </button>
          )}
          {activeImg < cat.images.length - 1 && (
            <button
              onClick={(e) => { e.stopPropagation(); setActiveImg(activeImg + 1); }}
              className="absolute right-3 top-1/2 -translate-y-1/2 w-9 h-9 flex items-center justify-center bg-white/80 hover:bg-white rounded-full cursor-pointer transition-colors"
            >
              <i className="ri-arrow-right-s-line text-gray-700 text-xl"></i>
            </button>
          )}
          <div className="absolute bottom-4 right-4 bg-black/40 text-white text-xs px-2 py-0.5 rounded-full">
            {activeImg + 1} / {cat.images.length}
          </div>
        </div>

        {/* 썸네일 */}
        <div className="flex gap-2 px-5 pt-4">
          {cat.images.map((img, idx) => (
            <button
              key={idx}
              onClick={() => setActiveImg(idx)}
              className={`flex-1 rounded-xl overflow-hidden cursor-pointer border-2 transition-all bg-gray-50 ${activeImg === idx ? 'border-green-500 scale-[1.03]' : 'border-transparent opacity-70 hover:opacity-100'}`}
              style={{ height: '100px' }}
            >
              <img src={img} alt={`${cat.name} 썸네일 ${idx + 1}`} className="w-full h-full object-contain" />
            </button>
          ))}
        </div>

        <div className="p-5">
          <div className="mb-4">
            <h3 className="text-xl font-extrabold text-gray-900">{cat.name}</h3>
            <p className="text-gray-500 text-sm mt-0.5">{cat.desc}</p>
          </div>

          {/* 가격 선택 영역 */}
          <div className="bg-green-50 rounded-2xl p-4 mb-4">
            <div className="flex items-center gap-1.5 mb-3">
              <i className="ri-price-tag-3-line text-green-600 text-lg"></i>
              <span className="text-sm font-bold text-gray-900">가격 선택</span>
              <span className="ml-auto text-xs text-green-600 font-medium">눌러서 주문에 담기</span>
            </div>
            <div className="grid grid-cols-2 gap-2">
              {cat.prices.map((p) => {
                const itemId = `${cat.id}-${p.weight}`;
                const isSelected = selectedItems.some((s) => s.id === itemId);
                const justAdded = addedId === itemId;
                return (
                  <button
                    key={p.weight}
                    onClick={() => handlePriceClick(p)}
                    className={`rounded-xl px-3 py-3 flex items-center justify-between cursor-pointer transition-all duration-200 border-2 ${
                      isSelected
                        ? 'bg-green-500 border-green-500 text-white'
                        : justAdded
                        ? 'bg-green-100 border-green-400'
                        : 'bg-white border-transparent hover:border-green-300 hover:bg-green-50'
                    }`}
                  >
                    <span className={`text-xs font-semibold ${isSelected ? 'text-white' : 'text-gray-600'}`}>{p.weight}</span>
                    <div className="flex items-center gap-1.5">
                      <span className={`text-sm font-extrabold ${isSelected ? 'text-white' : 'text-green-600'}`}>{p.price}</span>
                      {isSelected && <i className="ri-check-line text-white text-sm"></i>}
                    </div>
                  </button>
                );
              })}
            </div>
          </div>

          <div className="grid grid-cols-2 gap-3 mb-4">
            <div className="bg-gray-50 rounded-xl p-3">
              <div className="flex items-center gap-1.5 mb-1">
                <i className="ri-map-pin-line text-green-500 text-sm"></i>
                <span className="text-xs font-semibold text-gray-700">원산지</span>
              </div>
              <p className="text-xs text-gray-600">{cat.origin}</p>
            </div>
            <div className="bg-gray-50 rounded-xl p-3">
              <div className="flex items-center gap-1.5 mb-1">
                <i className="ri-calendar-line text-green-500 text-sm"></i>
                <span className="text-xs font-semibold text-gray-700">제철</span>
              </div>
              <p className="text-xs text-gray-600">{cat.season}</p>
            </div>
          </div>

          <div className="flex flex-col gap-3">
            <div className="bg-green-50 rounded-xl p-3">
              <div className="flex items-center gap-1.5 mb-1">
                <i className="ri-heart-line text-green-500 text-sm"></i>
                <span className="text-xs font-semibold text-gray-700">맛 &amp; 특징</span>
              </div>
              <p className="text-xs text-gray-600">{cat.taste}</p>
            </div>
            <div className="bg-orange-50 rounded-xl p-3">
              <div className="flex items-center gap-1.5 mb-1">
                <i className="ri-capsule-line text-orange-500 text-sm"></i>
                <span className="text-xs font-semibold text-gray-700">영양 성분</span>
              </div>
              <p className="text-xs text-gray-600">{cat.nutrition}</p>
            </div>
            <div className="bg-amber-50 rounded-xl p-3">
              <div className="flex items-center gap-1.5 mb-1">
                <i className="ri-lightbulb-line text-amber-500 text-sm"></i>
                <span className="text-xs font-semibold text-gray-700">보관 &amp; 섭취 팁</span>
              </div>
              <p className="text-xs text-gray-600">{cat.tip}</p>
            </div>
          </div>

          <button
            onClick={onClose}
            className="mt-5 w-full bg-gray-100 hover:bg-gray-200 text-gray-700 font-semibold py-3 rounded-full transition-colors cursor-pointer whitespace-nowrap"
          >
            닫기
          </button>
        </div>
      </div>
    </div>
  );
};

const FruitCard = ({
  cat,
  onClick,
  selectedItems,
}: {
  cat: Category;
  onClick: () => void;
  selectedItems: SelectedItem[];
}) => {
  const hasSelected = selectedItems.some((s) => s.id.startsWith(`${cat.id}-`));

  return (
    <div
      onClick={onClick}
      className={`rounded-2xl overflow-hidden cursor-pointer group transition-transform duration-200 hover:-translate-y-1 relative ${cat.bg} ${hasSelected ? 'ring-2 ring-green-400' : ''}`}
    >
      {hasSelected && (
        <div className="absolute top-2 right-2 z-10 w-6 h-6 flex items-center justify-center bg-green-500 rounded-full">
          <i className="ri-check-line text-white text-xs"></i>
        </div>
      )}
      <div className="relative w-full bg-white overflow-hidden" style={{ height: '160px' }}>
        <img
          src={cat.image}
          alt={cat.name}
          className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-300"
        />
        <span className={`absolute top-2 left-2 ${cat.badgeColor} text-white text-[9px] font-bold px-1.5 py-0.5 rounded-full`}>
          {cat.badge}
        </span>
      </div>
      <div className="p-2.5 md:p-3">
        <h3 className="font-bold text-gray-900 text-xs md:text-sm leading-tight">{cat.name}</h3>
        <p className="text-gray-500 text-[10px] mt-0.5 leading-tight">{cat.desc}</p>
        <div className="flex items-center justify-between mt-1.5">
          <span className="text-[10px] text-gray-500 font-medium">{cat.prices[0].weight}~</span>
          <span className="text-sm font-extrabold text-green-600">{cat.prices[0].price}</span>
        </div>
        <div className="mt-1.5 w-full text-center text-[10px] text-green-600 font-semibold bg-green-50 rounded-full py-1">
          눌러서 가격 선택
        </div>
      </div>
    </div>
  );
};

const FruitCategories = ({ onSelectItem, selectedItems }: FruitCategoriesProps) => {
  const [selected, setSelected] = useState<Category | null>(null);

  const row1 = categories.slice(0, 5);
  const row2 = categories.slice(5, 10);

  return (
    <section id="categories" className="py-16 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block text-xs font-semibold text-green-600 tracking-widest uppercase mb-3">
            BEST PRODUCTS
          </span>
          <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900 mb-3">
            인기 상품
          </h2>
          <p className="text-gray-500 text-sm md:text-base max-w-md mx-auto">
            가격을 클릭하면 주문에 바로 담을 수 있어요
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3 md:gap-4">
          {categories.map((cat) => (
            <FruitCard
              key={cat.id}
              cat={cat}
              onClick={() => setSelected(cat)}
              selectedItems={selectedItems}
            />
          ))}
        </div>
      </div>

      {selected && (
        <FruitDetailModal
          cat={selected}
          onClose={() => setSelected(null)}
          onSelectItem={onSelectItem}
          selectedItems={selectedItems}
        />
      )}
    </section>
  );
};

export default FruitCategories;